
class Session {

	unset (key) {
		return sessionStorage.removeItem(key);
	}

	set (key, value) {
		return sessionStorage.setItem(key, JSON.stringify(value));
	}

	get (key) {
		try {
			return JSON.parse(sessionStorage.getItem(key));
		} catch (e) {}
	}

}

Session.$inject = [];

export default angular.module('service.session', [])
	.service('Session', Session)
	.name;



// WEBPACK FOOTER //
// ./src/service/session.js